import React, { useRef } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from '@redturtle/iovisit-theme/components';
import { toPublicURL } from '@plone/volto/helpers/Url/Url';
import {
  Button,
  Dialog,
  DialogTrigger,
  ListBox,
  ListBoxItem,
  Popover,
} from 'react-aria-components';

const messages = defineMessages({
  share_on: { id: 'share_on', defaultMessage: 'Condividi su' },
  share_on_common: {
    id: 'share_on_common',
    defaultMessage: 'Condividi sui social',
  },
  shareButton: { id: 'shareButton', defaultMessage: 'Condividi questa pagina' },
});

const Sharing = ({ url, title, showLabel }) => {
  const intl = useIntl();
  const publicUrl = toPublicURL(url);
  const triggerRef = useRef(null);
  const socials = [
    {
      key: 'facebook',
      value: 'facebook',
      text: 'Facebook',
      url: `https://www.facebook.com/sharer/sharer.php?u=${publicUrl}`,
      icon: 'facebook-f',
    },
    {
      key: 'twitter',
      value: 'twitter',
      text: 'Twitter',
      url: `https://twitter.com/intent/tweet?url=${publicUrl}`,
      icon: 'twitter',
    },
    {
      key: 'linkedin',
      value: 'linkedin',
      text: 'LinkedIn',
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${publicUrl}&title=${publicUrl}`,
      icon: 'linkedin',
    },
    {
      key: 'whatsapp',
      value: 'whatsapp',
      text: 'Whatsapp',
      url: `https://api.whatsapp.com/send?phone=&text=${publicUrl}`,
      icon: 'whatsapp',
    },
    {
      key: 'telegram',
      value: 'telegram',
      text: 'Telegram',
      url: `https://t.me/share/url?url=${publicUrl}&text=${title}`,
      icon: 'telegram',
    },
  ];
  return (
    <div className="page-share">
      <DialogTrigger>
        <Button
          ref={triggerRef}
          className="ui icon button"
          aria-label={intl.formatMessage(messages.shareButton)}
        >
          <Icon prefix="fas" icon="share-alt" className="icon" />
          {showLabel && (
            <span className="icon-label">
              {intl.formatMessage(messages.share_on_common)}
            </span>
          )}
        </Button>

        <Popover
          className="popover-menu"
          placement="bottom end"
          triggerRef={triggerRef}
          isNonModal
          shouldCloseOnInteractOutside
        >
          <Dialog>
            <ListBox aria-label={intl.formatMessage(messages.share_on)}>
              {socials.map((item) => (
                <ListBoxItem key={item.key} textValue={item.text}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="item"
                    title={`${intl.formatMessage(messages.share_on)} ${item.text}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5em',
                    }}
                  >
                    <Icon prefix="fab" icon={item.icon} className="icon" />
                    {item.text}
                  </a>
                </ListBoxItem>
              ))}
            </ListBox>
          </Dialog>
        </Popover>
      </DialogTrigger>
    </div>
  );
};

export default Sharing;
